import { createContext, FC } from "react";

import type { Identity } from "./types";

export const AuthenticationRedirectContext = createContext<FC<{}> | null>(null);
export const IdentityContext = createContext<Identity | null>(null);
